var _path, _path2, _ellipse, _ellipse2, _ellipse3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompact(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 275,
    viewBox: "0 0 259 275",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M204.568 180.246C175.155 232.008 117.725 254.404 76.4314 230.89C35.1379 207.377 25.0179 146.517 54.4316 94.7545C83.8454 42.992 141.275 20.5964 182.569 44.1098C223.862 67.6232 233.982 128.483 204.568 180.246Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M184.298 137.382C184.298 140.066 182.922 142.728 180.207 145.258C177.491 147.789 173.505 150.114 168.497 152.088C158.486 156.033 144.587 158.495 129.185 158.495C113.783 158.495 99.8846 156.033 89.8736 152.088C84.8651 150.114 80.8797 147.789 78.1631 145.258C75.448 142.728 74.0717 140.066 74.0717 137.382C74.0717 134.698 75.448 132.036 78.1631 129.507C80.8797 126.976 84.8651 124.65 89.8736 122.677C99.8846 118.732 113.783 116.27 129.185 116.27C144.587 116.27 158.486 118.732 168.497 122.677C173.505 124.65 177.491 126.976 180.207 129.507C182.922 132.036 184.298 134.698 184.298 137.382Z",
    stroke: "white",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 150.513,
    cy: 118.574,
    rx: 12.4414,
    ry: 12.4543,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.998,
    cy: 41.3065,
    rx: 12.4414,
    ry: 12.4543,
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.1616,
    cy: 153.649,
    rx: 5.83985,
    ry: 5.84589,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompact);
export default __webpack_public_path__ + "static/media/Compact.7ed8feeead9f615f8df2c1e6143c1ac9.svg";
export { ForwardRef as ReactComponent };